import React from 'react';
import * as Icons from 'lucide-react';
import { steps } from '../mock/mock';

const HowItWorksStrip = () => {
  return (
    <section className="sect bg-[var(--rs-ink)] text-[var(--rs-cream)] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[420px] h-[420px] rounded-full bg-[var(--rs-green2)]/20 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] text-[var(--rs-coral)] mb-3">How it works</div>
          <h2 className="h-display text-4xl md:text-5xl">
            Four steps from order to a finished, signed-off job.
          </h2>
          <p className="mt-4 text-[var(--rs-cream)]/70 max-w-2xl">
            No friction, no chasing, no surprises. Every job is scheduled quickly and tracked in your dashboard from order to delivery.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <div key={i} className="relative p-6 rounded-2xl border border-[var(--rs-cream)]/15 bg-white/[0.04] hover:bg-white/[0.07] transition-colors">
                <div className="flex items-center justify-between">
                  <div className="w-11 h-11 rounded-lg bg-[var(--rs-coral)] grid place-items-center"><Icon className="w-5 h-5" /></div>
                  <span className="h-display text-3xl text-[var(--rs-cream)]/25">{s.step}</span>
                </div>
                <h3 className="h-display text-xl mt-5">{s.title}</h3>
                <p className="text-sm text-[var(--rs-cream)]/70 mt-2 leading-relaxed">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksStrip;
